/** @format */

import React from "react";
import { Formik, Form } from "formik";
import FormControl from "../forms/FormControl";
import Button from "./Button";
import { MdCancel } from "react-icons/md";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";
import { useAuth } from "../context/AuthContext";

const AdminLogin = () => {
  const { authState, handleHidePopup } = useAuth();
  const { adminLoginPopupState } = authState;

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string().email().required("Required"),
    password: Yup.string().min(6).required("Required"),
  });

  const onSubmit = (values, onSubmitProps) => {
    console.log(values);
    return onSubmitProps.resetForm(), handleHidePopup();
  };

  if (adminLoginPopupState) {
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <div className="login__form">
              <Form className="form">
                <div className="form__title--container">
                  <h2 className="form__title admin__login">ADMIN LOGIN</h2>
                  <MdCancel
                    onClick={handleHidePopup}
                    style={{ color: "rgb(202,8,8)", fontSize: "1.2rem" }}
                  />
                </div>
                <hr />
                <FormControl
                  control="input"
                  name="email"
                  label="Email"
                  placeholder="please enter email"
                  type="text"
                />

                <FormControl
                  control="input"
                  name="password"
                  label="Password"
                  type="password"
                  placeholder="please enter password"
                />
                <div className="submit__button">
                  <Button
                    btnText={
                      formik.isSubmitting ? (
                        <FaSpinner className="spinner"></FaSpinner>
                      ) : (
                        "Submit"
                      )
                    }
                    color="#fff"
                    type="submit"
                    bg="var(--success)"
                    btnBlock
                    disabled={!formik.isValid || formik.isSubmitting}
                  />
                  {!formik.isValid && (
                    <small style={{ color: "red", textAlign: "center" }}>
                      kindly fill all fields...
                    </small>
                  )}
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
    );
  } else {
    return <div></div>;
  }
};

export default AdminLogin;
